
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/yoga-meditation/additional-programs/[program]",
      function () {
        return require("private-next-pages/[region]/[language]/yoga-meditation/additional-programs/[program]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/yoga-meditation/additional-programs/[program]"])
      });
    }
  